export function getFragmentParams() {
  if (process.browser) {
    const { hash } = location;
    const withouthash = hash.substring(1);
    const fragmentKeys = withouthash.split("&");
    const splitFragments = fragmentKeys.map((_) => _.split("="));
    const fragmentMap = splitFragments.reduce((acc, curr) => ({
      ...acc,
      [curr[0]]: decodeURIComponent(curr[1]),
    }), {});
    return fragmentMap;
  }
  return {};
}
